import React, {useMemo} from "react";
import PropTypes from "prop-types";

const DrawerItemTitle = ({title, isCurrentPath}) => {
  const className = useMemo(
    () => isCurrentPath ? "DrawerItemTitle-isCurrentPath" : "",
    [isCurrentPath]
  );
  return (
    <div className={`DrawerItemTitle-Root ${className}`}>{title}</div>
  );
};

DrawerItemTitle.propTypes = {
  title: PropTypes.string,
  isCurrentPath: PropTypes.bool,
};

export default DrawerItemTitle;